import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../lib/api";

export default function CustomerAuth() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const tried = useRef(false);

  useEffect(() => {
    if (tried.current) return;
    tried.current = true;
    const token = params.get("token");
    if (!token) {
      setError("Missing login token.");
      return;
    }
    axios
      .post(`${API_URL}/auth/magic-login`, { token })
      .then(({ data }) => {
        localStorage.setItem("customer_token", data.token);
        navigate("/customer/conversations", { replace: true });
      })
      .catch((e) => setError(e?.response?.data?.detail || "This link is not valid."));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="customer-auth-page">
      {error ? (
        <div className="text-center max-w-sm" data-testid="customer-auth-error">
          <h1 className="text-2xl font-black">Link not valid</h1>
          <p className="mt-3 text-sm text-neutral-500">{error}</p>
          <Link to="/customer/login" className="mt-6 inline-block text-sm font-medium underline" data-testid="customer-auth-retry">
            Request a new login link
          </Link>
        </div>
      ) : (
        <p className="text-neutral-500" data-testid="customer-auth-loading">Signing you in…</p>
      )}
    </div>
  );
}
